import { render, staticRenderFns } from "./BringToTeam.vue?vue&type=template&id=2b2aa01c&scoped=true&"
import script from "./BringToTeam.vue?vue&type=script&lang=js&"
export * from "./BringToTeam.vue?vue&type=script&lang=js&"
import style0 from "./BringToTeam.vue?vue&type=style&index=0&id=2b2aa01c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2aa01c",
  null
  
)

export default component.exports